module.exports = __webpack_public_path__ + "img/angle-down.24c895d8.svg";